module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.cc4fde14.xml";